export const partners = [
  {
    name: "Honeywell",
    category: "Fire Safety",
    icon: require('../assets/partner_logo/HON-logo_200x37-2.png'),
    color: "#1e3a8a",
    tier: "Strategic Partner",
    projects: "150+",
    since: "2015",
    specialties: [
"Building Management",
"Fire Detection",
"Smoke Control",
"Emergency Lighting",
"Video Surveillance & IoT"
    ],
    url: "https://www.honeywell.com/us/en"
  },


   {
    name: "Huawei",
    category: "Networking & Infrastructure",
    icon: require('../assets/partner_logo/Huawei.jpg'),
    color: "#1e3a8a",
    tier: "Platinum Partner",
    projects: "200+",
    since: "2010",
    specialties: [
"Core Networking",
"Wireless Solutions",
"Data Centers"
    ],
    url: "/allproducts/"
  },
  {
    name: "Amate Audio",
    category: "Communication Systems",
    icon: require('../assets/partner_logo/amate_audio.jpeg'),
    color: "#059669",
    tier: "Certified Partner",
    projects: "80+",
    since: "2017",
    specialties: [
"Audio Systems",
"Sound Solutions",
"Public Address Systems",
"Concert Audio",
    ],
    url: "https://amateaudio.com/"
  },
  {
    name: "Mitel",
    category: "Communication Systems",
    icon: require('../assets/partner_logo/Mitel.jpg'),
    color: "#7c3aed",
    tier: "Gold Partner",
    projects: "120+",
    since: "2016",
    specialties: [
"VOIP Systems",
"Contact Center",
"Unified Communications",
"Cloud Telephony"
    ],
    url: "https://www.mitel.com/"
  },
  {
    name: "Voltvision",
    category: "Power & Energy Systems",
    icon: require('../assets/partner_logo/voltvision.png'),
    color: "#10b981",
    tier: "Certified Partner",
    projects: "70+",
    since: "2017",
    specialties: [
"UPS Systems",
"Solar Solutions",
"Power Backup",
"Smart Energy Management",
"Battery Storage",
"VBR",
"Hybrid Power Solutions"
    ],
    url: "http://voltvision.uk/"
  },
  {
    name: "Edwards",
    category: "Fire Safety",
    icon: require('../assets/partner_logo/edwards.jpg'),
    color: "#8b5cf6",
    tier: "Preferred Partner",
    projects: "100+",
    since: "2015",
    specialties: [
"Fire Detection",
"Alarm Panels",
"Smoke Detectors",
"Heat Sensors",
    ],
    url: "https://www.edwardsfiresafety.com/"
  },
  {
    name: "Uniguest",
    category: "Communication Systems",
    icon: require('../assets/partner_logo/Uniguest.png'),
    color: "#06b6d4",
    tier: "Digital Partner",
    projects: "50+",
    since: "2018",
    specialties: [
"IPTV Solutions",
"Digital Signage",
"Content Management Systems",
    ],
    url: "https://uniguest.com/"
  },
  {
    name: "SafeEye",
    category: "Networking & Infrastructure",
    icon: require('../assets/partner_logo/safeeye.png'),
    color: "#f97316",
    tier: "Security Partner",
    projects: "65+",
    since: "2018",
    specialties: [
"Access Control",
"PoE Switches",
"Security Gates and Barriers",
"Fire Suppression and Extinguishers",
"Cabling Solutions",
"IP Phones",
"Wall TVs & Displays",
    ],
    url: "https://safeeye.uk/"
  },
  {
    name: "Ankaro",
    category: "Communication Systems",
    icon: require('../assets/partner_logo/ANKARO.jpg'),
    color: "#ec4899",
    tier: "Technology Partner",
    projects: "45+",
    since: "2019",
    specialties: [
"Multimedia Solutions",
"Telecom Infrastructure",
"Satellite TV Systems",
"Signal Processing Equipment"
    ],
    url: "https://ankaro.net/"
  }
];

export const partnerCategories = [
  { name: "Communication Systems", count: 4 },
  { name: "Power & Energy", count: 1 },
  { name: "Networking & Infrastructure", count: 2 },
  { name: "Building Management", count: 1 },
  { name: "Fire Safety", count: 2 },
  { name: "Video Surveillance & IoT", count: 1 }
];
